import classNames from "classnames";
import styles from "./style.module.scss";
interface SwitchInterface {
  toggle: boolean;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function Switch(props: SwitchInterface) {
  const { toggle, handleChange } = props;

  return (
    <label className={classNames(styles.switch)}>
      <input type="checkbox" checked={toggle} onChange={handleChange} />
      <span
        className={classNames(
          styles.slider,
          styles.round,
          "slider round",
          toggle && styles.active,
        )}
      ></span>
    </label>
  );
}

export default Switch;
